export let DataSyncOptionApp;
(function (DataSyncOptionApp) {
  DataSyncOptionApp["Spreadsheet"] = "Spreadsheet";
  DataSyncOptionApp["Gmail"] = "Gmail";
  DataSyncOptionApp["Outlook"] = "Outlook or Exchange";
  DataSyncOptionApp["Mailchimp"] = "Mailchimp";
  DataSyncOptionApp["Zoho"] = "Zoho";
  DataSyncOptionApp["Pipedrive"] = "Pipedrive";
})(DataSyncOptionApp || (DataSyncOptionApp = {})); // From hub-http where no type is available